<template>
  <v-col cols="12" sm="12" md="12">
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <label class="label-modal">Utilizador já existente?</label>
        <v-radio-group
          :rules="rulesRequired"
          @change="ChangeExists()"
          mandatory
          v-model="values.estado"
          row
        >
          <v-radio :color="$primary" label="Não" value="0"></v-radio>
          <v-radio :color="$primary" label="Sim" value="1"></v-radio>
        </v-radio-group>
      </v-col>
      <v-col v-if="values.estado=='0'" cols="12" sm="12" md="12">
        <label class="label-modal">Nome</label>
        <v-text-field
          autocomplete="off"
          :rules="rulesRequired"
          v-model="MyObject.nome"
          :color="$primary"
        ></v-text-field>
      </v-col>
      <v-col v-if="values.estado=='1'" cols="12" sm="12" md="12">
        <label class="label-modal">Utilizador</label>
        <v-autocomplete
          :rules="rulesRequired"
          autocomplete="off"
          :items="AutoCompleteValues"
          @change="ChangeUser()"
          :color="$primary"
          v-model="values.id_utilizador"
          item-text="nome"
          item-value="id_utilizador"
        ></v-autocomplete>
      </v-col>
    </v-row>
  </v-col>
</template>
<script>
import CRUD from "@/mixins/_CRUD"
export default {
  mixins: [CRUD],
  props: {
    MyObject: Object,
    FormFields: Array
  },
  data: () => ({
    values: {}
  }),
  computed: {
    getSession() {
      return this.$store.getters["session/getState"]
    },
    AutoCompleteValues() {
      return this.$store.getters["utilizador/getAll"]
    },
    rulesRequired() {
      return this.FormFields[1].rules
    }
  },
  mounted() {},
  methods: {
    ChangeExists() {
      if (
        Number(this.values.estado) == 0 &&
        Number(this.values.id_utilizador) > 0
      ) {
        delete this.values.id_utilizador
        setTimeout(() => {
          this.$eventBus.$emit("ResetForm")
        }, 50)
      }
    },
    ChangeUser() {
      var obj = Object.assign(
        {},
        this.$store.getters["utilizador/getAll"].find(el => {
          return el.id_utilizador == this.values.id_utilizador
        })
      )

      if (typeof obj == "undefined") return

      this.$eventBus.$emit("SetMyObjectValues", {
        nome: obj.nome,
        email: obj.email,
        nif: obj.nif
      })
    }
  }
}
</script>
